'use client';

import { ApolloProvider } from '@apollo/client';
import { PropsWithChildren } from 'react';
import client from '@/utils/apolloClient';

const Layout = ({ children }: PropsWithChildren) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default Layout;
